import $http from "../../axios";import {Notification, MessageBox} from 'element-ui';

export async function fetchBranchOffices({commit, state}) {
    await $http.get('/api/sedes')
        .then((response) => {
            commit('setBranchOffices', response.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
            commit('BranchOfficeError', error.message)
        })
}
export async function fetchReportTransfers({commit, state}) {
    state.loading.module = true;
    await $http.get('/api/reporte-traslados',{params : state.params}).then((response) => {
            state.loading.module = false;
            commit('setReportTransfers', response.data)
        })
        .catch((error) => {
            state.loading.module = false;
            Notification.error({
                title: 'Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}
export async function fetchDocumentsProducts({commit, state},document_id) {
    await $http.get('/api/reporte-traslados/productos/'+document_id,).then((response) => {
            commit('setDocumentsProductsTransfer', response.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}
export async function downloadDocumentTransfer({state}, document_p) {
    let name = document_p.type_voucher + ' No. ' + document_p.consecutive + '.pdf'
    await $http({
        url: '/api/traslado/descargar-pdf/'+document_p.thread,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    })
}



// WEBPACK FOOTER //
// ./src/modules/report-transfers/actions.js